import React from 'react';

// Switches how a document's lines are shown, for that screen only — the
// saved line order (the customer's, as entered) never changes (issue #304).
// Quote and Sales Order open in Line order; Pick Order and the Pick Slip
// open in SKU order (pick order is a warehouse concern, worked out when
// shown rather than stored). Each screen holds the choice in plain state,
// so it's back to its default next time.
export const LINE_ORDERS = [
  { key: 'sku', label: 'SKU', title: 'Sequence by SKU' },
  { key: 'document', label: 'Line', title: 'Sequence by line number' },
];

export function inLineOrder(lines, lineOrder) {
  if (lineOrder !== 'document') return lines;
  return [...lines].sort((a, b) => (a.sequence - b.sequence) || (a.id - b.id));
}

// For a screen whose lines are already in document order (Quote, Sales
// Order — the array order is what gets saved).
export function bySku(lines) {
  return [...lines].sort((a, b) => (a.product?.sku || '').localeCompare(b.product?.sku || ''));
}

function LineOrderSwitch({ value, onChange, style }) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, ...style }}>
      <span style={{ fontSize: 12, color: '#888', fontWeight: 600 }}>Sequence</span>
      <div style={{ display: 'inline-flex', border: '1px solid #bfc8d6', borderRadius: 6, overflow: 'hidden' }}>
        {LINE_ORDERS.map((o, i) => (
          <button
            key={o.key}
            type="button"
            title={o.title}
            onClick={() => onChange(o.key)}
            style={{
              padding: '4px 10px',
              border: 'none',
              borderLeft: i === 0 ? 'none' : '1px solid #bfc8d6',
              background: value === o.key ? '#1976d2' : '#fff',
              color: value === o.key ? '#fff' : '#333',
              fontWeight: 600,
              fontSize: 12,
              cursor: 'pointer',
            }}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default LineOrderSwitch;
